import type { LineMarkProps } from "./types-gantt";
import { useGanttLineMark } from "./use-gantt-line-mark";
import { LineMarkView } from "./view-gantt-line-mark";

/** Linha fina com o rótulo acima (etapa Obra dos Gantts por Obra e Fornecedor). */
export function LineMark(props: LineMarkProps) {
  const viewModel = useGanttLineMark(props);

  return <LineMarkView {...viewModel} />;
}
LineMark.displayName = "LineMark";
